import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_wd64rb2zkz_thi_5c43b43988: FaireThemeEntity = {
  token: "board_demo_r_wd64rb2zkz_thi_5c43b43988",
  type: "theme",
  retailerToken: "r_wd64rb2zkz",
  name: "Unique and Affordable Iowa Falls Kids Gifts",
  description:
    "A curated collection of unique and affordable baby gifts and toys that align with the local Iowa Falls market preference for accessible boutique finds.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/7e089da23d9d811c0b14a94c849f51520cb99d8af5286a1fcba320edb6fbf546.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/7e089da23d9d811c0b14a94c849f51520cb99d8af5286a1fcba320edb6fbf546.jpeg",
    "https://cdn.faire.com/fastly/321adc66aad27caa498ac86e63c8afb573362c65e1a4e525531782a55b45a40a.jpeg",
    "https://cdn.faire.com/fastly/67fb61bf285f49801b1558b94cdd51913cc9801fad72ec49673d57d7574edb63.jpeg",
    "https://cdn.faire.com/fastly/98f166ace4ead9680cf5ac398b8465e08ab5a0aeb4f44270efc05223b53dad95.jpeg",
    "https://cdn.faire.com/fastly/e7c14bedb19f33769e60e901932207ab7ab90d3e803b6ebc0fbf1f9fb0270c3a.jpeg",
    "https://cdn.faire.com/fastly/296f7e7c93dc099e1606a8055d96c5ad839687ba661e20ea6578439d6a9f3438.jpeg",
  ],
  itemCount: 63,
  source: "eric_themes_ideas",
  teaser: "thi_5c43b43988",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
